import { ColorNames } from '@/utils/constants';

const resolveColorName = ({ rawVal }: { rawVal: string }) => {
  if (/^eggshell|light|"eggshell"$/i.test(rawVal)) {
    return ColorNames.eggshell;
  }

  if (/^dark-gray|"dark-gray"$/i.test(rawVal)) {
    return ColorNames.darkGray;
  }

  if (/^charcoal|dark|"charcoal"$/i.test(rawVal)) {
    return ColorNames.charcoal;
  }

  if (/^black|"black"$/i.test(rawVal)) {
    return ColorNames.black;
  }

  if (/^white|"white"$/i.test(rawVal)) {
    return ColorNames.white;
  }

  if (/^medium-gray|"medium-gray"$/i.test(rawVal)) {
    return ColorNames.mediumGray;
  }

  if (/^blue|"blue"$/i.test(rawVal)) {
    return ColorNames.blue;
  }

  return undefined;
};

export default resolveColorName;
